import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { useMapRadiusContext } from '@/components/MapOverview/components/MapRadiusContextProvider';
import { NCCardSectionHeader } from '@/components/NCCard/NCCard';

import { ProtectedAreasTable } from './components/ProtectedAreasTable';

export const ProtectedAreasStatsTile = ({
  protectedAreasSummary,
}: {
  protectedAreasSummary: PlotReportFactElement[];
}) => {
  return (
    <Stack className='gap-8 px-6 py-8 lg:gap-4' data-testid='protected-areas-stats-tile'>
      <ProtectedAreas protectedAreas={protectedAreasSummary} />
    </Stack>
  );
};

const ProtectedAreas = ({ protectedAreas }: { protectedAreas: PlotReportFactElement[] }) => {
  const { t } = useTranslation();
  const { radius } = useMapRadiusContext();

  return (
    <div className='flex flex-col gap-8 lg:gap-4'>
      <NCCardSectionHeader
        title={t('shared.ncaDetail.details.protectedAreas.stats.header.title', {
          radius,
        })}
        popover={{
          title: t('shared.ncaDetail.details.protectedAreas.stats.header.title', {
            radius,
          }),
          body: t('shared.ncaDetail.details.protectedAreas.stats.header.titleTooltip'),
        }}
      />
      <Stack className='mt-4 gap-4 rounded-2xl px-4 py-6'>
        <div className='max-h-[400px] overflow-y-auto w-full'>
          <ProtectedAreasTable data={protectedAreas} />
        </div>
      </Stack>
    </div>
  );
};
